import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPropertyCottageCreateRequestDTO,
	postPropertyCottageV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePostPropertyCottageMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(
			(requestContract: ClientPropertyCottageCreateRequestDTO) =>
				postPropertyCottageV2(requestContract),
		),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.propertyLists(),
			});
		},
	});
};
